/**
 * Update Banner Component
 * FT-135: Shows notification when new version is available
 *
 * This banner appears at the top of the page when the service worker
 * detects a new version. User can click to refresh and get the update.
 */

import React from 'react';
import { RefreshCw, X } from 'lucide-react';

export const UpdateBanner = ({ onUpdate, onDismiss }) => {
  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-cyan-600 text-white px-4 py-3 shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <RefreshCw className="h-5 w-5 animate-spin" />
          <span className="text-sm font-medium">
            A new version of FleetSkipper is available
          </span>
        </div>
        <div className="flex items-center space-x-2">
          <button
            onClick={onUpdate}
            className="inline-flex items-center px-3 py-1.5 bg-white text-cyan-600 text-sm font-medium rounded-md hover:bg-cyan-50 transition-colors"
          >
            Update Now
          </button>
          <button
            onClick={onDismiss}
            className="p-1.5 hover:bg-cyan-700 rounded-md transition-colors"
            aria-label="Dismiss"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateBanner;
